export default {
  name: {
    id: 'rm_metal_titanium_name',
    defaultMessage: 'Titanium',
  },
  smartphoneLabel: {
    id: 'rm_metal_titanium_smartphone_label',
    defaultMessage: 'Low (about a grain of rice)',
  },
  whatItDoesText: {
    id: 'rm_metal_titanium_what_it_does',
    defaultMessage:
      'Titanium is lightweight, strong and highly resistant to corrosion. It is used in some smartphones, particularly in frames or other structural components, although the amount and applications vary by model.',
  },
  extractionText1: {
    id: 'rm_metal_titanium_extraction_p1',
    defaultMessage:
      'Most titanium is mined as ilmenite or rutile, often from heavy-mineral sands. The ore is separated using gravity, magnetic and electrostatic methods, then processed into titanium dioxide, titanium slag or titanium tetrachloride. To produce titanium metal, titanium tetrachloride is reduced with magnesium to make titanium sponge, which is melted into ingots and alloys.',
  },
  quickFactText: {
    id: 'rm_metal_titanium_quick_fact',
    defaultMessage:
      'Titanium mining can reshape more than landscapes: thousands of people were displaced in connection with Kenya’s Kwale project between 2001 and 2007.',
  },
  envSummaryText: {
    id: 'rm_metal_titanium_env_summary',
    defaultMessage:
      'Titanium mining can disturb land, remove vegetation, consume water and energy, and generate waste rock and tailings. Mining heavy mineral sands containing ilmenite and rutile can significantly disturb coastal dune ecosystems and may affect shoreline stability. The chlorine-based Kroll process used to produce titanium sponge, an intermediate in titanium metal production, can generate hazardous waste and air emissions, including chlorine gas leaks and waste magnesium chloride, requiring careful management.',
  },
  envWaterText: {
    id: 'rm_metal_titanium_env_water_text',
    defaultMessage:
      'Heavy-mineral-sands mining and mineral processing can consume water and generate wastewater and tailings. Titanium and its compounds may enter waterways, and potential effects on aquatic ecosystems remain under study.',
  },
  envBiodiversityText: {
    id: 'rm_metal_titanium_env_biodiversity_text',
    defaultMessage:
      'Heavy-mineral-sands mining can alter coastal or inland habitats and affect vegetation and wildlife. Potential effects of titanium compounds on aquatic organisms also remain under study.',
  },
  humanSummaryText: {
    id: 'rm_metal_titanium_human_summary',
    defaultMessage:
      'Mining titanium-bearing mineral sands has raised concerns about community displacement, land conflicts, reduced access to water, and impacts on farming, fishing and other livelihoods in several countries. Public-health and environmental-justice concerns linked to hazardous waste and chlorine gas emissions from titanium sponge production have also been reported in the United States.',
  },
  humanDisplacementText: {
    id: 'rm_metal_titanium_human_displacement_text',
    defaultMessage:
      'In Kenya, at least 7,000 people were displaced between 2001 and 2007 in connection with the Kwale titanium project. Compensation was provided, but it was reported to be insufficient for many affected people. Later mining operations in Kwale also displaced people and animals, affected farming areas, and caused conflicts over land ownership, land use and land value. In Madagascar, mining activities affected habitats that support farming, grazing and ecological tourism.',
  },
  humanWaterText: {
    id: 'rm_metal_titanium_human_water_text',
    defaultMessage:
      'In Madagascar, soil excavation and dam construction reduced local access to water and affected fishing livelihoods. In Vietnam, authorities required clean-water facilities and an environmental impact assessment after temporarily suspending a mining operation.',
  },
  humanHealthText: {
    id: 'rm_metal_titanium_human_health_text',
    defaultMessage:
      'Increased dust, noise and water pollution around the Kwale mine have been reported, as have reduced access to water and fishing resources in Madagascar. In Vietnam, a landslide reportedly killed four workers in 2022. Public-health concerns related to chlorine gas leaks and hazardous waste from titanium sponge production have also been raised in the United States.',
  },
  geoSummaryText: {
    id: 'rm_metal_titanium_geo_summary',
    defaultMessage:
      'Titanium supply is concentrated at both the mining and processing stages, with China being the largest producer of titanium mineral concentrates. Geopolitical tensions, including the Russia-Ukraine war, have affected supply chains. Titanium is classified as a strategic raw material under the EU Critical Raw Materials Act (2024).',
  },
  geoDugText: {
    id: 'rm_metal_titanium_geo_dug_text',
    defaultMessage:
      'China, Mozambique and South Africa together accounted for approximately 70% of reported 2024 production of ilmenite and rutile, the main titanium-bearing mineral concentrates. China alone accounted for around 35% of the combined total.',
  },
  geoProcessedText: {
    id: 'rm_metal_titanium_geo_processed_text',
    defaultMessage:
      'On average between 2020 and 2024, China accounted for approximately 64% of global processing-stage production, followed by Japan at 19%, Russia at 8%, Kazakhstan at 5% and Saudi Arabia at 3%.',
  },
  geoLeverageText: {
    id: 'rm_metal_titanium_geo_leverage_text',
    defaultMessage:
      'No broad export restrictions on titanium itself were documented as of the writing date, but geopolitical tensions can still affect supply. Russia’s VSMPO-AVISMA, historically one of the world’s largest titanium producers, has faced Western sanctions since 2022, disrupting aerospace supply chains without constituting a formal trade restriction on titanium itself. The war in Ukraine has also affected Ukrainian production. China’s large processing capacity gives it significant influence, although certification concerns limit the use of some Chinese titanium in European aerospace supply chains. Titanium is classified as a strategic raw material under the EU Critical Raw Materials Act (2024).',
  },
  supplySummaryText: {
    id: 'rm_metal_titanium_supply_summary',
    defaultMessage:
      'Supply may struggle to keep pace with demand growth in the short term, particularly for aerospace-grade titanium. Production has been affected by geopolitical tensions, while new capacity in Japan, Saudi Arabia and China could ease pressure. The European Union remains fully dependent on imports for titanium processing-stage supply.',
  },
  supplyReservesText: {
    id: 'rm_metal_titanium_supply_reserves_text',
    defaultMessage:
      'Global resources of anatase, ilmenite and rutile exceed 2 billion tonnes. Reported reserves exceed 510 million tonnes of ilmenite and 46 million tonnes of rutile, for a combined total of more than 560 million tonnes. Australia has the largest reported reserves, with 180 million tonnes of ilmenite and more than 35 million tonnes of rutile. China follows with 110 million tonnes of ilmenite, while Canada reports 51 million tonnes. These figures concern titanium-bearing minerals, not refined titanium metal.',
  },
  supplyDemandText: {
    id: 'rm_metal_titanium_supply_demand_text',
    defaultMessage:
      'More than 90% of titanium mineral consumption is used to produce titanium dioxide pigment, while just over 5% is used to make titanium metal. Demand for titanium metal is driven mainly by aerospace, defence, medical equipment, automotive applications and handheld products. Demand for titanium from clean-energy technologies is projected to rise from 4.3 kt in 2025 to 7.8 kt in 2050, an increase of approximately 81%.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_titanium_recycling_summary',
    defaultMessage:
      'Titanium recycling is relatively effective for manufacturing scrap, particularly in the aerospace industry, where 80% to 90% of suitable scrap can be reintroduced into ingot production. End-of-life recycling is more limited because scrap can contain oxygen and iron impurities. In consumer electronics, the end-of-life recycling rate for titanium is close to 0%.',
  },
  recyclingInputText: {
    id: 'rm_metal_titanium_recycling_input_text',
    defaultMessage:
      'The end-of-life recycling input rate for titanium is estimated at approximately 19%. Most recovered old scrap is used to produce ferro-titanium rather than high-purity titanium metal. During the production of titanium ingots, scrap typically accounts for around 30% of the input, although the share can reach 75% depending on the technology. These figures do not concern smartphones specifically.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_titanium_recycling_outlook_text',
    defaultMessage:
      'Partly, but not entirely. High-quality manufacturing scrap can be cleaned and remelted into titanium ingots, while lower-grade scrap is often diverted to ferro-titanium production. End-of-life recycling remains more difficult because titanium is dispersed across products, scrap can be contaminated and much European production scrap is exported for processing. Primary titanium production will therefore remain necessary.',
  },
  footnote1Text1: {
    id: 'rm_metal_titanium_footnote_1_p1',
    defaultMessage:
      'As Titanium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  mine0Region: {
    id: 'rm_metal_titanium_mine0_region',
    defaultMessage: 'Panzhihua',
  },
  mine1Region: {
    id: 'rm_metal_titanium_mine1_region',
    defaultMessage: 'Moma',
  },
  mine2Region: {
    id: 'rm_metal_titanium_mine2_region',
    defaultMessage: 'Richards Bay',
  },
  mine3Region: {
    id: 'rm_metal_titanium_mine3_region',
    defaultMessage: 'Sokndal',
  },
  mine4Region: {
    id: 'rm_metal_titanium_mine4_region',
    defaultMessage: 'Mombasa',
  },
  mine5Region: {
    id: 'rm_metal_titanium_mine5_region',
    defaultMessage: 'Havre-Saint-Pierre',
  },
} as const
